import { withScenarioQuery } from "features/shared/lib/technical-config-tab/api/withScenarioQuery";
import { ProjectId } from "features/shared/model/types";

const url = `${process.env.REACT_APP_ENERGY_DASHBOARD_API_URL}/api/roomconfigtab`;

export default {
  catalog: (activeOnly = true) => `${url}/room-type-db?activeOnly=${activeOnly}`,
  createCatalogItem: () => `${url}/room-type-db`,
  groupDetail: (projectId: ProjectId, roomFunctionType: string, scenario?: string) =>
    withScenarioQuery(`${url}/projects/${projectId}/room-types/${encodeURIComponent(roomFunctionType)}`, scenario),
  groups: (projectId: ProjectId, scenario?: string) =>
    withScenarioQuery(`${url}/projects/${projectId}/room-types`, scenario),
  schedulePreset: (kind: string) => `${url}/schedules/${kind}`,
};
